const DEFAULT_SEASON_ID = (import.meta.env.VITE_DEFAULT_SEASON_ID as string) ?? 'S1'
const DEFAULT_SEASON_LABEL = (import.meta.env.VITE_DEFAULT_SEASON_LABEL as string) ?? 'Temporada Atual'

export function getCurrentSeasonId() {
  return DEFAULT_SEASON_ID
}

export function getCurrentSeasonLabel() {
  return DEFAULT_SEASON_LABEL
}

export function getMonthKey(now = new Date()) {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
}

export function getDaysUntil(targetDateIso: string, now = new Date()) {
  const target = new Date(targetDateIso)
  const diff = target.getTime() - now.getTime()
  if (diff <= 0) return 0
  return Math.ceil(diff / (24 * 60 * 60 * 1000))
}

export function getDaysUntilNextMonth(now = new Date()) {
  const startNextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1)
  return getDaysUntil(startNextMonth.toISOString(), now)
}

export function canChangeUsernameMonthly(lastChangedAt?: string, now = new Date()) {
  if (!lastChangedAt) {
    return { allowed: true, remainingDays: 0 }
  }

  const changed = new Date(lastChangedAt)
  const sameMonth = changed.getFullYear() === now.getFullYear() && changed.getMonth() === now.getMonth()
  if (!sameMonth) {
    return { allowed: true, remainingDays: 0 }
  }

  return {
    allowed: false,
    remainingDays: getDaysUntilNextMonth(now),
  }
}

export function buildUsernameRedirectUntil(now = new Date()) {
  return new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000).toISOString()
}

export function formatDateTimeLabel(isoDate?: string) {
  if (!isoDate) return '--'
  const date = new Date(isoDate)
  return `${date.toLocaleDateString('pt-BR')} ${date.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  })}`
}
